import React from 'react';

import { ContainerHeader } from '~components';
import { faUserNurse } from '~components/icon';

// TAV-2635 placeholder — replaced by the care plans list view in TAV-2638.
const CarePlansList: React.FC = () => {
  return (
    <div className="p-3">
      <ContainerHeader icon={faUserNurse} dataCy="care-plans-list-header">
        Care Plans
      </ContainerHeader>
    </div>
  );
};

export default CarePlansList;
